<template>
  <div>
    <b-row class="mb-3 text-bold">
      <b-col cols="12">
        <legend class="p-3 d-flex flex-column">
          <span v-html="question.question"> </span>
          <div class="d-flex flex-row mt-3 mx-auto" v-if="selectMultiple">
            <div><b-icon icon="question-circle-fill"></b-icon></div>
            <div class="font-size-12 my-auto ml-2 font-weight-normal">
              Zaznacz więcej niż jedną odpowiedź
            </div>
          </div>
        </legend>
      </b-col>
    </b-row>
    <b-row class="mb-3 text-bold">
      <b-col
        lg="12"
        class="pb-3"
        v-if="question.image && question.image !== ''"
      >
        <b-img :src="examImagesPath + question.image" fluid></b-img>
      </b-col>
      <b-col>
        <b-form-group label-class="p-3">
          <b-form-radio-group v-if="selectOne" class="">
            <div class="mt-2 text-center align-content-start">
              <b-row class="text-left mx-auto my-3">
                <b-col
                  lg="6"
                  class="d-flex align-content-center"
                  v-for="(answer, index) in question.answers"
                  :key="index"
                >
                  <label
                    class="
                      btn btn-white
                      p-3
                      bg-white
                      rounded-lg
                      border
                      font-size-16 font-weight-bold
                      w-100
                      text-left
                    "
                    ><input
                      type="radio"
                      :name="'selected-answer-one' + questionIndex"
                      :value="index"
                      v-model="selectedAnswerOne"
                    /><span class="position-relative top-minus-1">
                      {{ answer }}</span
                    ></label
                  >
                </b-col>
              </b-row>
            </div>
          </b-form-radio-group>

          <b-form-checkbox-group v-else>
            <div class="mt-2 text-center align-content-start">
              <b-row class="text-left d-flex flex-row mx-auto my-3">
                <b-col
                  lg="6"
                  class="d-flex align-content-center"
                  v-for="(answer, index) in question.answers"
                  :key="index"
                >
                  <label
                    class="
                      btn btn-white
                      p-3
                      bg-white
                      rounded-lg
                      border
                      font-size-16 font-weight-bold
                      w-100
                      text-left
                    "
                    ><input
                      type="checkbox"
                      :name="'selected-answer-multiple' + questionIndex"
                      :value="index"
                      v-model="selectedAnswerMultiple" /><span
                      class="position-relative top-minus-1"
                      v-html="' ' + answer"
                    >
                    </span
                  ></label>
                </b-col>
              </b-row>
            </div>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'CourseExamQuestion',
  data() {
    return {
      selectedAnswerOne: {},
      selectedAnswerMultiple: [],
    };
  },
  props: {
    question: {},
    questionIndex: {},
    progressCurrent: {},
    examImagesPath: {},
  },
  created() {},
  computed: {
    selectOne() {
      return this.question.type === 'one_answer';
    },
    selectMultiple() {
      return this.question.type === 'multiple_answers';
    },
  },
  watch: {
    selectedAnswerOne(newVal, oldVal) {
      this.onSelectedChange(newVal);
    },
    selectedAnswerMultiple(newVal, oldVal) {
      this.onSelectedChange(newVal);
    },
    progressCurrent(newVal, oldVal) {
      if (this.progressCurrent === this.questionIndex) {
        this.onToggleNextBtn(
          this.selectOne ? this.selectedAnswerOne : this.selectedAnswerMultiple
        );
      }
    },
  },
  methods: {
    onSelectedChange(val) {
      this.onToggleNextBtn(val);
      this.$emit('onChangeAnswer', {
        questionIndex: this.questionIndex,
        value: val,
      });
    },
    onToggleNextBtn(val) {
      if (
        (this.selectOne && typeof val === 'number') ||
        (this.selectMultiple && typeof val !== 'undefined' && val.length > 0)
      ) {
        this.$emit('onToggleNextBtn', false);
      } else {
        this.$emit('onToggleNextBtn', true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  legend {
    color: white !important;
    background: var(--sidebar-color) !important;
  }
  .answer {
    width: 45% !important;
    label > * {
      cursor: pointer;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.5) !important;
    }
  }
}
</style>
